import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { H1 } from '@finect/tabular-core/Headings';
export { InfoLabelsBlock } from './InfoLabelsBlock';
export { SubtitleSimple, Subtitle, SubtitleClassname, SubtitleISIN } from './Subtitle';
export { ScoreBlock, ReviewLink } from './ScoreBlock';
export var Info = styled.div.withConfig({
  displayName: "partials__Info",
  componentId: "sc-1lmslfb-0"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;", ";"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-wrap: nowrap;\n  "]))));
export var Title = styled(H1).withConfig({
  displayName: "partials__Title",
  componentId: "sc-1lmslfb-1"
})(["display:block;margin-bottom:6px;", " &:not(:last-child){padding-bottom:0;}", ""], getFont(2), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    padding-right: 70px;\n    ", "\n  "])), getFont(3)));
export var QuotesContainer = styled.div.withConfig({
  displayName: "partials__QuotesContainer",
  componentId: "sc-1lmslfb-2"
})(["display:flex;flex-flow:column;flex-shrink:0;margin-bottom:12px;", ";"], minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]))));